import { fromJS, Map } from "immutable";
import { GenericActions } from "../../../redux/generic-actions";
import { componentsReducer } from "../../../redux/root.reducer";
import { GenericFormActions } from "../actions";

export function fieldGroupListReducerFactory(rootProp, initialState) {
    return function fieldGroupListReducer(state = initialState, action) {
        const stateProp: string = action.stateProp;
        state = componentsReducer(rootProp, state, action);
        switch (action.type) {
            case `${rootProp}::${GenericFormActions.BLANK_GROUP_ADDED}`:
                const groupCount = state.getIn([stateProp, "groups"]).count();
                const payload = Map(action.payload.groupContext);
                return state.setIn([stateProp, "groups", groupCount], payload);
            case `${rootProp}::${GenericFormActions.GROUPS_LOADED}`:
                return state.setIn([stateProp, "groups"], fromJS(action.payload));
            case `${rootProp}::${GenericFormActions.GROUP_REMOVED}`:
                state = state.deleteIn([stateProp, "groups", action.payload]);
                return state;
            case `${rootProp}::${GenericActions.STATE_RESET}`:
                return initialState;
            default:
                return state;
        }
    };
}
